import request from '@/utils/request'
/**
 *
 * 商品管理
 *
 **/
// 查询列表接口
export const getGoodsPage = (params: any) => {
  return request({
    url: '/admin/goods/page',
    method: 'get',
    params
  })
}

// 删除接口
export const deleteGoods = (ids: string) => {
  return request({
    url: '/admin/goods',
    method: 'delete',
    params: { ids }
  })
}

// 修改接口
export const editGoods = (params: any) => {
  return request({
    url: '/admin/goods',
    method: 'put',
    data: { ...params }
  })
}

// 新增接口
export const addGoods = (params: any) => {
  return request({
    url: '/admin/goods',
    method: 'post',
    data: { ...params }
  })
}

// 查询详情
export const queryGoodsById = (id: string | (string | null)[]) => {
  return request({
    url: `/admin/goods/${id}`,
    method: 'get'
  })
}

// 获取商品分类列表
export const getCategoryList = (params: any) => {
  return request({
    url: '/admin/category/list',
    method: 'get',
    params
  })
}

// 查商品列表的接口
export const queryGoodsList = (params: any) => {
  return request({
    url: '/admin/goods/list',
    method: 'get',
    params
  })
}

// 文件down预览
export const commonDownload = (params: any) => {
  return request({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    url: '/admin/common/download',
    method: 'get',
    params
  })
}

// 起售停售---批量起售停售接口
export const goodsStatusByStatus = (params: any) => {
  return request({
    url: `/admin/goods/status/${params.status}`,
    method: 'post',
    params: { id: params.id }
  })
}

//商品分类数据查询
export const goodsCategoryList = (params: any) => {
  return request({
    url: `/admin/category/list`,
    method: 'get',
    params: { ...params }
  })
}
